import { Component, Input } from '@angular/core';
@Component({
	selector: 'app-movimento-tab',
  	templateUrl: './tab.component.html',
  	styleUrls: ['./tab.component.scss']
})
export class MovimentoTabComponent{
	@Input() desativado:boolean = false;
}
